<div fxFlex="100">
<calsoft-xl-mapper [title]="'Deals Advance Xl'"  [type]="11" [serviceUrl]="'updateDealXl'" [urlNew]="'deals'">

</calsoft-xl-mapper>
</div>
